import React, { Component } from 'react';

import withStyles from '@material-ui/core/styles/withStyles';

import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';

import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import { MdRemoveRedEye } from 'react-icons/md';
import { Delete } from '@material-ui/icons';

const styles = theme => ({
  tableRight: { minWidth: 'min-content' },
  smallTableCell: { padding: '0px 0px 0px 4px' },
  tableBorder: { width: '100%' },
  card: {
    width: 'auto',
    margin: '10px',
    display: 'inline-block',
  },
  media: {
    height: '100%',
    border: '3px solid rgba(255, 255, 255, 1)',
  },
});

class ImageLibraryTable extends Component {
  render() {
    const {
      classes,
      imageList,
      confirmDelete,
      imageOrderBy,
      updateSort,
      leagueId,
      team,
    } = this.props;

    const HtmlTooltip = withStyles(theme => ({
      tooltip: {
        background: 'rgba(255, 255, 255, 1)',
        width: 'auto',
      },
    }))(Tooltip);

    return (
      <div
        className="image-container"
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Table className={classes.tableBorder}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.smallTableCell}>
                <TableSortLabel
                  active={imageOrderBy === '-fileName' || imageOrderBy === 'fileName'}
                  direction={imageOrderBy === '-fileName' ? 'desc' : 'asc'}
                  onClick={() => updateSort('fileName', leagueId, team)}
                >
                  Name
                </TableSortLabel>
              </TableCell>
              <TableCell className={classes.smallTableCell}>
                <TableSortLabel
                  active={
                    imageOrderBy === '-metadata.leagueName' ||
                    imageOrderBy === 'metadata.leagueName'
                  }
                  direction={imageOrderBy === '-metadata.leagueName' ? 'desc' : 'asc'}
                  onClick={() => updateSort('metadata.leagueName', leagueId, team)}
                >
                  League
                </TableSortLabel>
              </TableCell>
              <TableCell className={classes.smallTableCell}>
                <TableSortLabel
                  active={
                    imageOrderBy === '-metadata.teamName' ||
                    imageOrderBy === 'metadata.teamName'
                  }
                  direction={imageOrderBy === '-metadata.teamName' ? 'desc' : 'asc'}
                  onClick={() => updateSort('metadata.teamName', leagueId, team)}
                >
                  Team
                </TableSortLabel>
              </TableCell>
              <TableCell className={classes.smallTableCell}>
                <TableSortLabel
                  active={imageOrderBy === '-createdAt' || imageOrderBy === 'createdAt'}
                  direction={imageOrderBy === '-createdAt' ? 'desc' : 'asc'}
                  onClick={() => updateSort('createdAt', leagueId, team)}
                >
                  Created At
                </TableSortLabel>
              </TableCell>
              <TableCell className={classes.smallTableCell}>Options</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {imageList.map(row =>
              row.metadata ? (
                <TableRow key={row._id} hover>
                  <TableCell className={classes.smallTableCell}>{row.fileName}</TableCell>
                  <TableCell className={classes.smallTableCell}>
                    {row.metadata.leagueName ? row.metadata.leagueName : 'N/A'}
                  </TableCell>
                  <TableCell className={classes.smallTableCell}>
                    {row.metadata.teamName ? row.metadata.teamName : 'N/A'}
                  </TableCell>
                  <TableCell className={classes.smallTableCell}>
                    {moment(row.createdAt).format('lll')}
                  </TableCell>

                  <TableCell className={classes.smallTableCell}>
                    <React.Fragment>
                      <IconButton
                        color="primary"
                        disabled={row.hasDependencies ? true : false}
                        onClick={() => {
                          confirmDelete(row._id, row.fileName);
                        }}
                      >
                        <Delete />
                      </IconButton>
                      <HtmlTooltip
                        title={
                          <React.Fragment>
                            {
                              <Card className={classes.card}>
                                <CardMedia
                                  style={{
                                    width: '120px',
                                    height: '120px',
                                  }}
                                  className={classes.media}
                                  image={`https://${row.container}.s3.amazonaws.com/${row.blob}`}
                                />
                              </Card>
                            }
                          </React.Fragment>
                        }
                      >
                        <IconButton color="primary">
                          <MdRemoveRedEye />
                        </IconButton>
                      </HtmlTooltip>
                    </React.Fragment>
                  </TableCell>
                </TableRow>
              ) : null
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={this.props.countImages}
          rowsPerPage={this.props.imagePageSize}
          page={this.props.imagePage}
          onPageChange={this.props.onChangeImagePage}
          onRowsPerPageChange={this.props.onChangeRowsPerImagePage}
        />
      </div>
    );
  }
}
export default withStyles(styles)(ImageLibraryTable);
